import React from "react";
import { useSelector } from "react-redux";

const BusyContainer = (props) => {
  const isBusy = useSelector(
    (state) => state.busy.isBusy && state.busy.isWrite
  );

  return <div style={{ opacity: isBusy ? 0.2 : 1 }}>{props.children}</div>;
};

export default BusyContainer;
